module.exports = __webpack_public_path__ + "idea-management-3-217791a31d87624149358e6cd0b381e9.webp";